import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
const InviteYourColleagues = (props) => {


   // console.log(props.labels)
    const [enabledCopiedTraveladminLink, setEnabledCopiedTraveladminLink] = useState(false)
    const [enabledCopiedTravelerLink, setEnabledCopiedTravelerLink] = useState(false)
    const [travelerSmartLink, settravelerSmartLink] = useState('')
    const [travelAdminSmartLink, settravelAdminSmartLink] = useState('')

    useEffect(() => {
        
        // const profSession = JSON.parse(sessionStorage.getItem('prof-profile'));
        // if (profSession) {
        //     profSession['smartLinks'] = JSON.parse(sessionStorage.getItem('smartLinks'));
        //     sessionStorage.setItem('prof-profile', JSON.stringify(profSession));
        // }

        //  settravelerSmartLink(`${window.location.origin}${getLocalizedUrl('/#/customer/join/')}${props.getSessionStorage?.smartLinks.travelerLink}`)
        // settravelAdminSmartLink(`${window.location.origin}${getLocalizedUrl('/#/customer/join/')}${props.getSessionStorage?.smartLinks.travelAdminLink}`)
    }, []);

    const getLocalizedUrl = (url) => {
        const regexForLocale = /^[a-z]{2}[-][a-z]{2}$/;
        const regexForLocale2 = /^([a-z]{2})$/;
        let locale = window.location.pathname.split('/')[1];
        if (url.charAt(0) !== '/') {
            url = '/' + url;
        }
        if (regexForLocale.test(locale) || regexForLocale2.test(locale)) {
            return `/${locale}${url}`;
        } else {
            return url;
        }
    }

    const smartLinkCheck = () => {

        if (Object.keys(props.getSessionStorage).length > 0 && props.getSessionStorage.smartLinks) {
            if (travelerSmartLink === '' && travelAdminSmartLink === '') {
                settravelerSmartLink(`${window.location.origin}${getLocalizedUrl(`/#/customer/join/${props.getSessionStorage?.smartLinks.travelerLink}`)}`);
                settravelAdminSmartLink(`${window.location.origin}${getLocalizedUrl(`/#/customer/join/${props.getSessionStorage?.smartLinks.travelAdminLink}`)}`);

            }
        } else {
            if (travelerSmartLink === '' && travelAdminSmartLink === '') {
                settravelerSmartLink(`${window.location.origin}${getLocalizedUrl(`/#/customer/join/${JSON.parse(window.sessionStorage.getItem('smartLinks')).travelerLink}`)}`);
            }
        }
    }
    smartLinkCheck();
    //console.log(travelerSmartLink);
    const addToProfile = () => {
        window.sessionStorage.setItem('corporateSignup', 'success')
        window.location.href = "/customer-integrations/#/corporate-signup-success";
        // window.location.href = smartLink;
    }
    const copyLinkTravelAdmin = param => event => {
        navigator.clipboard.writeText(param);
        setEnabledCopiedTravelerLink(false)
        setEnabledCopiedTraveladminLink(true)
    };
    const copyLinkTraveler = param => event => {
        navigator.clipboard.writeText(param);
        setEnabledCopiedTravelerLink(true)
        setEnabledCopiedTraveladminLink(false)
    };
    
    const backToStart = () => {
        window.location.href = '/'
    }
    return <>
    {props.labels['corporate.signup.link.copied'] &&
    // <s4s-modal heading={props.labels['corporate.signup.success.popup.title']} >
    <div className="popup-model">
        <div element="modal" class="flysas modal open null" id="template" role="dialog" aria-modal="true" aria-labelledby="template-title" data-onload="false">
    <div className="success-page-wrapper">
            <div className='inner-wrapper modal-content'>
            <button  type="button" class="btn-close smartlink-close" data-close="true" aria-label="Close" onClick={(e) => addToProfile()(e)}>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.177 3l2.121 2.121L11.77 9.65l4.528 4.528-2.121 2.121-4.528-4.528-4.528 4.528L3 14.177l4.527-4.528L3 5.121 5.121 3 9.65 7.527z" fill-rule="evenodd"></path></svg>
            </button>
            <div className="inner-title-success">{props.labels['corporate.signup.success.popup.title']}</div>
                <div className="invite-colleagues-des">{props.labels['corporate.signup.success.description']}</div>
              
                    {/* <div className="smartlink-wrapper">
                        <div className="travel-smartlink-title">Travel admin smart link</div>
                        <div className="link-conpay-button">
                        <input type="text" defaultValue={travelerSmartLink} name="search" readOnly className="smart-link-input " />
                        <button className='smart-link-copy-button btn-secondary' type="submit" id="link-copy" onClick={(e) => copyLinkTravelAdmin(travelerSmartLink)(e)} >{props.labels['corporate.signup.copy.link']}</button>
                        </div>
                        {enabledCopiedTraveladminLink && <><div className="copied">{props.labels['corporate.signup.link.copied']}! </div>
                        </>}
                    </div> */}
                    <div className="smartlink-wrapper">
                        {/* <div className="travel-smartlink-title">Traveler  smart link</div> */}
                        <div className="link-conpay-button">
                        <input type="text" defaultValue={travelerSmartLink} name="search" readOnly className="smart-link-input " />
                        <button className='smart-link-copy-button btn-secondary' type="submit" id="link-copy" onClick={(e) => copyLinkTraveler(travelAdminSmartLink)(e)} >{props.labels['corporate.signup.copy.link']}</button>
                        </div>
                        {enabledCopiedTravelerLink && <><div className="copied">{props.labels['corporate.signup.link.copied']}! </div>
                        </>}
                    </div>
                    <div className="smartlink-close-button"><button onClick={(e) => addToProfile()(e)}>Close</button></div>
               
            </div>
            </div>
            </div>  
            </div>
        // </s4s-modal>
}
    </>
}



const mapStateFromReducer = (state) => ({
    labels: state.corporateSignupReducer.labels || {},
    getSessionStorage: state.corporateSignupReducer.getSessionStorage || {}
})

export default connect(
    mapStateFromReducer,
    null
)(InviteYourColleagues);